import up_arrow from "../assets/green_arrow_up.png";
import down_arrow from "../assets/red_arrow_down.png";


const DiagnosticEngagementTabular = (props) => {

    const firstThemes = props.firstThemes
    const secondThemes = props.secondThemes
    const showTeamMembers = props.showTeamMembers
    const showTeamLeaders = props.showTeamLeaders
    const showStakeholders = props.showStakeholders
    const tabularColour = props.tabularColour
    const getSurveyPoint = props.getSurveyPoint
    const getRoleAverageScore = props.getRoleAverageScore
    const getFunctionValue = props.getFunctionValue
    const getTeamAverageScore = props.getTeamAverageScore
    const data = props.data
    const display = props.display
    const title = props.title
    const renderDecoration = props.renderDecoration
    const subscription = props.subscription

    const idx_array = [0, 1, 2, 3, 4]


    const getComparisonArrow = (idx, role) => {
        let _first_value
        let _second_value
        let _role
        if (role) {
            switch (role) {
                case 1: _role = "tm"; break;
                case 2: _role = "tl"; break;
                case 3: _role = "sh"; break;
            }
            _first_value = getRoleAverageScore(firstThemes[idx], _role)
            _second_value = getRoleAverageScore(secondThemes[idx], _role)
        } else {
            _first_value = getTeamAverageScore(firstThemes[idx])
            _second_value = getTeamAverageScore(secondThemes[idx])
        }

        if (_first_value < _second_value) {
            return <img src={up_arrow} alt="positive"/>
        } else if (_first_value > _second_value){
            return <img src={down_arrow} alt="negative"/>
        } else {
            return <div className="comparison-dash">-</div>
        }
    }

    const asNumber = (v) => {
        if (typeof v === "number") return v;
        if (typeof v === "string" && v.trim() !== "") {
            const n = Number(v);
            return Number.isFinite(n) ? n : NaN;
        }
        return NaN;
    };
    const showScore = (v, { requireStakeholders=false, theme } = {}) => {
        if (requireStakeholders && (theme?.stakeholder_scores?.length ?? 0) === 0) return "N/A";
        const n = asNumber(v);
        return Number.isFinite(n) ? n : "N/A";
    };


    return (
        <div className={display ? "comparison-tabular-card-container" : "hidden"}
             style={{boxShadow: !renderDecoration ? "unset" : null, padding: !renderDecoration ? "0 30px" : null}}>
            <div className={`premium-watermark-container ${subscription < 1 && "locked"}`}>
                <div className="comparison-tabular-card-header" style={{marginBottom: !renderDecoration ? "unset" : null}}>
                    {title}
                </div>
                {firstThemes ?
                    <div className="comparison-tabular-header-row">
                        <div className="comparison-tabular-header empty"/>
                        {idx_array && idx_array.map((idx) => {
                            return <div className="comparison-tabular-header" key={idx}>{firstThemes[idx].name}</div>
                        })}
                    </div> : null
                }
                <div className="comparison-tabular-colour-row">
                    <div className="comparison-tabular-colour-container empty">
                        <div className="comparison-tabular-colour empty"/>
                    </div>
                    {firstThemes && firstThemes.map((theme, idx) => {
                        return (
                            <div className="comparison-tabular-colour-container" key={idx}>
                                <div className={`comparison-tabular-colour ${tabularColour}`}/>
                            </div>
                        )
                    })}
                </div>
                <div className="comparison-tabular-point-row">
                    <div className="comparison-tabular-point-column start">Survey Point</div>
                    {firstThemes && firstThemes.map((theme, idx) => {
                        return (
                            <div className="comparison-tabular-point-column" key={idx}>
                                <div className="comparison-tabular-point">
                                    {getSurveyPoint(data.surveys[0].survey_point)}
                                </div>
                                <div className="comparison-tabular-point">
                                    {getSurveyPoint(data.surveys[1].survey_point)}
                                </div>
                            </div>
                        )
                    })}
                </div>
                {showTeamMembers && firstThemes && secondThemes ?
                    <div className="comparison-tabular-role-row light">
                        <div className="comparison-tabular-role-column">
                            <div className="comparison-tabular-role-icon tm"/>
                            Team Member Mean
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {getRoleAverageScore(firstThemes[0], "tm")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[0], "tm")}
                                {getComparisonArrow(0, 1)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div
                                className="comparison-tabular-theme-value mid">
                                {getRoleAverageScore(firstThemes[1], "tm")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[1], "tm")}
                                {getComparisonArrow(1, 1)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {getRoleAverageScore(firstThemes[2], "tm")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[2], "tm")}
                                {getComparisonArrow(2, 1)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {getRoleAverageScore(firstThemes[3], "tm")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[3], "tm")}
                                {getComparisonArrow(3, 1)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {getRoleAverageScore(firstThemes[4], "tm")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[4], "tm")}
                                {getComparisonArrow(4, 1)}
                            </div>
                        </div>
                    </div> : null
                }
                {showTeamLeaders && firstThemes && secondThemes ?
                    <div className="comparison-tabular-role-row mid">
                        <div className="comparison-tabular-role-column">
                            <div className="comparison-tabular-role-icon tl"/>
                            Team Leader Mean
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value dark">
                                {getRoleAverageScore(firstThemes[0], "tl")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[0], "tl")}
                                {getComparisonArrow(0, 2)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value dark">
                                {getRoleAverageScore(firstThemes[1], "tl")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[1], "tl")}
                                {getComparisonArrow(1, 2)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value dark">
                                {getRoleAverageScore(firstThemes[2], "tl")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[2], "tl")}
                                {getComparisonArrow(2, 2)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value dark">
                                {getRoleAverageScore(firstThemes[3], "tl")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[3], "tl")}
                                {getComparisonArrow(3, 2)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value dark">
                                {getRoleAverageScore(firstThemes[4], "tl")}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {getRoleAverageScore(secondThemes[4], "tl")}
                                {getComparisonArrow(4, 2)}
                            </div>
                        </div>
                    </div> : null
                }
                {showStakeholders && firstThemes && secondThemes ?
                    <div className="comparison-tabular-role-row light">
                        <div className="comparison-tabular-role-column">
                            <div className="comparison-tabular-role-icon sh"/>
                            Stakeholder Mean
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {showScore(getRoleAverageScore(firstThemes[0], "sh"), { requireStakeholders:true, theme:firstThemes[0] })}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {showScore(getRoleAverageScore(secondThemes[0], "sh"), { requireStakeholders:true, theme:secondThemes[0] })}
                                {getComparisonArrow(0, 3)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {showScore(getRoleAverageScore(firstThemes[1], "sh"), { requireStakeholders:true, theme:firstThemes[0] })}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {showScore(getRoleAverageScore(secondThemes[1], "sh"), { requireStakeholders:true, theme:secondThemes[0] })}
                                {getComparisonArrow(1, 3)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {showScore(getRoleAverageScore(firstThemes[2], "sh"), { requireStakeholders:true, theme:firstThemes[0] })}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {showScore(getRoleAverageScore(secondThemes[2], "sh"), { requireStakeholders:true, theme:secondThemes[0] })}
                                {getComparisonArrow(2, 3)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {showScore(getRoleAverageScore(firstThemes[3], "sh"), { requireStakeholders:true, theme:firstThemes[0] })}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {showScore(getRoleAverageScore(secondThemes[3], "sh"), { requireStakeholders:true, theme:secondThemes[0] })}
                                {getComparisonArrow(3, 3)}
                            </div>
                        </div>
                        <div className="comparison-tabular-theme-column">
                            <div className="comparison-tabular-theme-value mid">
                                {showScore(getRoleAverageScore(firstThemes[4], "sh"), { requireStakeholders:true, theme:firstThemes[0] })}
                            </div>
                            <div className="comparison-tabular-theme-value">
                                {showScore(getRoleAverageScore(secondThemes[4], "sh"), { requireStakeholders:true, theme:secondThemes[0] })}
                                {getComparisonArrow(4, 3)}
                            </div>
                        </div>
                    </div> : null
                }
                <div className="comparison-tabular-spacer-row">
                    <div className="comparison-tabular-role-column empty"/>
                    <div className="comparison-tabular-theme-column empty"/>
                    <div className="comparison-tabular-theme-column empty"/>
                    <div className="comparison-tabular-theme-column empty"/>
                    <div className="comparison-tabular-theme-column empty"/>
                    <div className="comparison-tabular-theme-column empty"/>
                </div>
                {firstThemes && secondThemes ?
                    <>
                        <div className="comparison-tabular-role-row mid">
                            <div className="comparison-tabular-role-column">
                                <div className="comparison-tabular-role-icon empty"/>
                                Team Mean
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value dark">
                                    {getTeamAverageScore(firstThemes[0])}
                                </div>
                                <div className="comparison-tabular-theme-value">
                                    {getTeamAverageScore(secondThemes[0])}
                                    {getComparisonArrow(0, 0)}
                                </div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value dark">
                                    {getTeamAverageScore(firstThemes[1])}
                                </div>
                                <div className="comparison-tabular-theme-value">
                                    {getTeamAverageScore(secondThemes[1])}
                                    {getComparisonArrow(1, 0)}
                                </div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value dark">
                                    {getTeamAverageScore(firstThemes[2])}
                                </div>
                                <div className="comparison-tabular-theme-value">
                                    {getTeamAverageScore(secondThemes[2])}
                                    {getComparisonArrow(2, 0)}
                                </div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value dark">
                                    {getTeamAverageScore(firstThemes[3])}
                                </div>
                                <div className="comparison-tabular-theme-value">
                                    {getTeamAverageScore(secondThemes[3])}
                                    {getComparisonArrow(3, 0)}
                                </div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value dark">
                                    {getTeamAverageScore(firstThemes[4])}
                                </div>
                                <div className="comparison-tabular-theme-value">
                                    {getTeamAverageScore(secondThemes[4])}
                                    {getComparisonArrow(4, 0)}
                                </div>
                            </div>
                        </div>
                        <div className="comparison-tabular-role-row light">
                            <div className="comparison-tabular-role-column">
                                <div className="comparison-tabular-role-icon empty"/>
                                Function
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value">{getFunctionValue(firstThemes[0])}</div>
                                <div className="comparison-tabular-theme-value">{getFunctionValue(secondThemes[0])}</div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value">{getFunctionValue(firstThemes[1])}</div>
                                <div className="comparison-tabular-theme-value">{getFunctionValue(secondThemes[1])}</div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value">{getFunctionValue(firstThemes[2])}</div>
                                <div className="comparison-tabular-theme-value">{getFunctionValue(secondThemes[2])}</div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value">{getFunctionValue(firstThemes[3])}</div>
                                <div className="comparison-tabular-theme-value">{getFunctionValue(secondThemes[3])}</div>
                            </div>
                            <div className="comparison-tabular-theme-column">
                                <div className="comparison-tabular-theme-value">{getFunctionValue(firstThemes[4])}</div>
                                <div className="comparison-tabular-theme-value">{getFunctionValue(secondThemes[4])}</div>
                            </div>
                        </div>
                    </> : null
                }
            </div>
        </div>
    )
}

export default DiagnosticEngagementTabular